import React from 'react';
import PropTypes from 'prop-types';

export default function RowLabels({ rowLabels, minWidth }) {
  return (
    <div className="bipolar-horizontal-row-labels" style={{ minWidth }}>
      <span
        className="bipolar-horizontal-row-label bipolar-horizontal-row-label--left"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: rowLabels.beforeLabel || '&nbsp;' }}
      ></span>
      <span
        className="bipolar-horizontal-row-label bipolar-horizontal-row-label--right" // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: rowLabels.afterLabel || '&nbsp;' }}
      ></span>
    </div>
  );
}
RowLabels.propTypes = {
  rowLabels: PropTypes.array,
  minWidth: PropTypes.number,
};
